 <template>
 <div>
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

     <div>

     </div>
 <div>
  <v-data-table
    :headers="headers"
    :items="emolumentos"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Emolumentos

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initialize(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>
<div>
    <v-alert v-if="sucess" type="success">
      Pagamento feito com sucesso.
    </v-alert>

    <v-alert v-if="err" type="error">
      O pagamento não foi feito com sucesso.
    </v-alert>
  </div>
            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">
                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                      <v-text-field
                        v-model="editedItem.nome"
                        label="Nome do Emolumento"
                         :rules="obrigqtorioRules"
                         :disabled="isEdit"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                       <v-text-field

                        v-model="editedItem.preco"
                        :rules="ruleTextRequiredPagamento"
                        label="Preço"

                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                :disabled="!(formValid)"
                text
                @click="save()"
                v-if="!isEdit"
                >Salvar</v-btn>
                 <v-btn
                color="blue darken-1"
                :disabled="!(formValid)"
                text
                @click="editItem()"
                v-if="isEdit"
                >Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="openDialog(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:item.rascunho="{ item }">
      <v-switch  v-model="item.rascunho_"  @change="MudarStatus(item)"  ></v-switch>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
export default {
  directives: { mask },
  data: () => ({
    text: '',
    flag_curso: '',
    formValid: true,
    usuarios: [],
    modal: false,
    isLoading: false,
    search: '',
    cursos: [],
    usuariosJaExistentes: [],
    obrigqtorioRules: [value => !!value || 'campo obrigatorio'],
    ruleTextRequiredPagamento: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /(([.,0-9]))$/
        return !!pattern.test(value) || 'Invalido.'
      }
    ],
    emolumentos: [],
    sucess: false,
    err: false,
    dialog: false,
    isEdit: false,
    headers: [
      {
        text: 'Nome do Emolumento',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Preço (Unitario)', value: 'preco' },
      { text: 'Sufixo', value: 'sufixo' },
      { text: 'Modificado', value: 'auto_data' },
      { text: 'Actions', value: 'action', sortable: false },
      { text: 'Rascunho', value: 'rascunho' }
    ],

    editedIndex: -1,
    editedItem: {
      pkemolumentos: 0,
      preco: '',
      nome: ''
    },
    defaultItem: {
      pkemolumentos: 0,
      preco: 0,
      nome: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Novo Emolumento' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeEmolumentos()
  },

  methods: {


    async MudarStatus(item){
        try {
          let result = await axios
          .post('/emolumentoRascunho', item)
          .then(res => res.data)
          if(result.affectedRows >=1){
            this.$store.dispatch('textMessage', { msg:'Alteração efectuada com sucesso', classMessage: 'msgSucess', timeout: 3000})
          }else{
            item.rascunho_ = !item.rascunho_
            this.$store.dispatch('textMessage', { msg:'Ocorreu um erro ao efectuar a operação.', classMessage: 'msgError', timeout: 3000})
          }
        } catch (error) {
          item.rascunho_ = !item.rascunho_
            this.$store.dispatch('textMessage', { msg:'Ocorreu um erro ao efectuar a operação.', classMessage: 'msgError', timeout: 3000})
        }
    },

    async initializeEmolumentos (search) {
      this.isLoading = true
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }

        this.emolumentos = await axios
          .get('/emolumentosAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    openDialog (item) {
      this.isEdit = true
      this.dialog = true
      this.editedItem = item
    },
    async editItem () {
      var params = {
        pkemolumentos: this.editedItem.pkemolumentos,
        nome: this.editedItem.nome,
        preco: this.editedItem.preco

      }
      try {
        let msg = await axios
          .post('/EmolumentosInsertOrUpdate', params)
          .then(res => res.data)
        // this.text = msg[1].insertId

        this.text = ' Emolumento actualizado com sucesso'
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })

        try {
          if (msg.affectedRows >= 1) {
            this.text = ' Emolumento actualizado com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
            this.editedIndex = this.emolumentos.indexOf(this.editedItem)
            this.editedItem = Object.assign({}, this.editedItem)
            this.sucess = true
            setTimeout(() => {
              this.sucess = false
            }, 2000)
          }
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
          this.err = true
          setTimeout(() => {
            this.err = false
          }, 2000)
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        this.dialog = false
        this.isEdit = false
      }
    },

    async deleteItem (item) {
      const index = this.emolumentos.indexOf(item)
      var params = {
        pkemolumentos: item.pkemolumentos

      }
      try {
        let msg = await axios
          .post('/EmolumentosDelete', params)
          .then(res => res.data)
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })

        try {
          if (msg.affectedRows >= 1) {
            this.text = ' Emolumento eliminado com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
            this.emolumentos.splice(index, 1)
            this.sucess = true
            setTimeout(() => {
              this.sucess = false
            }, 2000)
          }
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
          this.err = true
          setTimeout(() => {
            this.err = false
          }, 2000)
        } catch (error) {}
        try {
          this.text = msg.message.sqlMessage
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
      }
    },

    close () {
      this.dialog = false
      this.isEdit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save () {
      if (this.$refs.form.validate() && this.editedItem.nome && this.editedItem.preco) {
        try {
          var params = {
            pkemolumentos: this.editedItem.pkemolumentos,
            nome: this.editedItem.nome,
            preco: this.editedItem.preco

          }
        } catch (error) {

        }

        try {
          let msg = await axios
            .post('/EmolumentosInsertOrUpdate', params)
            .then(res => res.data)
            // this.text = msg[1].insertId

          this.text = msg
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 2000
          })

          try {
            if (msg.affectedRows >= 1) {
              this.text = ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
              this.sucess = true
              setTimeout(() => {
                this.sucess = false
              }, 2000)
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
            this.err = true
            setTimeout(() => {
              this.err = false
            }, 2000)
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
          this.emolumentos.unshift(params)
          this.editedItem.pkemolumentos = 0
          this.editedItem.preco = ''
          this.editedItem.nome = ''
          this.close()
        }
      }
    }
  }

}
</script>
